import { selectGetUID } from '@selectors/auth';

import request from '@utils/request';

import * as endpoints from '@common/endpoints';
import * as actions from '../actions/customerDetail';

export const fetchCustomerDetail = () => (dispatch, getState) => {
  const customerId = selectGetUID(getState());

  if (!customerId) {
    return Promise.resolve();
  }

  dispatch(actions.getCustomerDetailRequest());

  return request
    .get(endpoints.customerDetail(customerId))
    .then(({ data }) => {
      dispatch(actions.getCustomerDetailSuccess(data));
    })
    .catch(error => {
      dispatch(actions.getCustomerDetailFailure(error));
    });
};

export const updateCustomerDetail = detail => (dispatch, getState) => {
  const customerId = selectGetUID(getState());

  dispatch(actions.updateCustomerDetailRequest());

  return request
    .patch(endpoints.customerDetail(customerId), detail)
    .then(response => {
      dispatch(actions.updateCustomerDetailSuccess(response.data));

      return response;
    })
    .catch(error => {
      dispatch(actions.updateCustomerDetailFailure(error));

      throw error;
    });
};

export const createCustomerDetail = details => dispatch => {
  dispatch(actions.createCustomerDetailRequest());

  return request
    .post(endpoints.createCustomer(), details)
    .then(({ data }) => {
      dispatch(actions.createCustomerDetailSuccess(data));

      return data;
    })
    .catch(error => {
      dispatch(actions.createCustomerDetailFailure(error));

      throw error;
    });
};
